"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _provider = _interopRequireDefault(require("../../provider"));
var _ChromeOSExtensionService = _interopRequireDefault(require("./ChromeOSExtensionService"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class ChromeOSMetricsProvider extends _provider.default {
  constructor(extensionId) {
    super();
    this._service = new _ChromeOSExtensionService.default(extensionId);
  }
  async collectAll() {
    const metrics = await this._service.collectAll();
    if (!metrics) return null;
    return {
      ...metrics,
      signal_strength_normalized: metrics.signal_strength_normalized ?? null,
      cpu_load_pct: metrics.cpu_load_pct ?? null,
      device_uptime: metrics.device_uptime ?? null
    };
  }
  async getConnectionType() {
    const metrics = await this._service.collectAll();
    return metrics ? metrics.connection_type : null;
  }
  async getNetworkMetrics() {
    const metrics = await this._service.collectAll();
    if (!metrics) return null;
    return {
      has_link: metrics.has_link,
      essid: metrics.essid,
      // ChromeOS does not expose signal_strength_dbm via networking.onc
      signal_strength_dbm: null,
      signal_strength_normalized: metrics.signal_strength_normalized ?? null,
      frequency_mhz: metrics.frequency_mhz
    };
  }
  async getSystemMetrics() {
    const metrics = await this._service.collectAll();
    if (!metrics) return null;
    return {
      // ChromeOS does not expose Unix-style load averages
      cpu_load_1m: null,
      cpu_load_5m: null,
      cpu_load_15m: null,
      cpu_load_pct: metrics.cpu_load_pct ?? null,
      temperature_celsius: metrics.temperature_celsius,
      memory_total_bytes: metrics.memory_total_bytes,
      memory_free_bytes: metrics.memory_free_bytes,
      device_uptime: metrics.device_uptime ?? null
    };
  }
  getDeviceName() {
    return this._service.getDeviceName();
  }
  async getDeviceId() {
    const metrics = await this._service.collectAll();
    return metrics ? metrics.device_id : null;
  }
}
var _default = exports.default = ChromeOSMetricsProvider;